// extracted by mini-css-extract-plugin
export default {"content":"TariffsModalContent__content--1UxIz","isIframe":"TariffsModalContent__isIframe--3fsbM","title":"TariffsModalContent__title--2b66V"};